/* eslint-disable @typescript-eslint/naming-convention */
export enum OnboardingActionTypesEnum {
    SET_ONBOARDING_CONTEXT = "SET_ONBOARDING_CONTEXT",
    SET_DEVICE_REQUEST = "SET_DEVICE_REQUEST",
    SET_ONBOARDING_ACCESSTOKEN = "SET_ONBOARDING_ACCESSTOKEN",
    SET_ONBOARDING_MANAGED_PROCESS = "SET_ONBOARDING_MANAGED_PROCESS",
}
